import PropTypes from "prop-types";
import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../common/Auth"
import SubscribeEmail from "../../components/newsletter/SubscribeEmail";
import SubscribeEditIcon from "../../pages/subscribe/SubscribeEditIcon"

const Newsletter = ({
  bgColorClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass
}) => {

  const { themeSettingsData, userType } = useContext(AuthContext)
  const [subscribe, setSubscribe] = useState({})
  const [subscribeId, setSubscribeId] = useState("")

  useEffect(() => {
    themeSettingsData.map((i) => {
      if (i.settingsName === "subscribe") {
        setSubscribe(i.values[0]);
        setSubscribeId(i._id);
      }
    })
  }, [themeSettingsData])
  let pt = subscribe.paddingTop ? subscribe.paddingTop : "pt-50";
  let pb = subscribe.paddingBottom ? subscribe.paddingBottom : "pb-50";
  let mb = subscribe.marginBottom ? subscribe.marginBottom : "mb-50";
  let mt = subscribe.marginTop ? subscribe.marginTop : "mt-50";
  let mr = subscribe.marginRight ? subscribe.marginRight : "mr-0";
  let ml = subscribe.marginLeft ? subscribe.marginLeft : "ml-0";
  let pl = subscribe.paddingLeft ? subscribe.paddingLeft : "pl-0";
  let pr = subscribe.paddingRight ? subscribe.paddingRight : "pr-0";
  let fullSection = subscribe.fullSection ? "container-fluid" : "container";
  let bgImage = subscribe?.image ? subscribe?.image : "";
  let bgColor = subscribe?.bgColor ? subscribe?.bgColor : "";

  let title = subscribe.title ? subscribe.title : "SUBSCRIBE NOW"
  let desc = subscribe.description ? subscribe.description : "SUBSCRIBE TO OUR NEWSLETTER"

  return (
    <div className={`subscribe-area bg-img ${bgColorClass ? bgColorClass : ""}  ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr}`}
    style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}
    >
      <div className={`${fullSection}`}>
        <div className="row">
          <div className="col-xl-8 col-lg-8 ml-auto mr-auto">
            {subscribeId && (
              <div className="edit-inline">
                <SubscribeEditIcon subscribeId={subscribeId} fromEditAction="topBottomspace" />
              </div>
            )}
            <div className="subscribe-style-2 text-center">
              {subscribe && (
                <>
                  {subscribeId && (
                    <div className="edit-inline">
                      <SubscribeEditIcon subscribeId={subscribeId} fromEditAction="title" />
                    </div>
                  )}
                  <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
                  {subscribeId && (
                    <div className="edit-inline">
                      <SubscribeEditIcon subscribeId={subscribeId} fromEditAction="desc" />
                    </div>
                  )}
                  <p dangerouslySetInnerHTML={{ __html: desc }}></p>

                  {subscribeId && (
                    <div className="edit-inline">
                      <SubscribeEditIcon subscribeId={subscribeId} fromEditAction="btn" />
                    </div>
                  )}
                  {/* subscription form */}
                  <SubscribeEmail mailchimpUrl="//devitems.us11.list-manage.com/subscribe/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef" placeholderText={subscribe.placeholderText} />
                </>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Newsletter.propTypes = {
  bgColorClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string
};

export default Newsletter;
